import { makeStyles } from "@material-ui/styles";

export default makeStyles(theme => ({
  dashedBorder: {
    border: "1px dashed",
    borderColor: theme.palette.primary.main,
    padding: theme.spacing(2),
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
    marginTop: theme.spacing(1),
  },
  text: {
    marginBottom: theme.spacing(2),
  },
  tableOverflow: {
    overflow: 'auto'
  },
  tableWidget: {
    overflowX: "auto",
  },
  green: {
    backgroundColor: theme.palette.green.main,
    color: '#fff',
  },
  yellow: {
    backgroundColor: theme.palette.yellow.main,
    color: '#fff',
  },
  gray: {
    backgroundColor: theme.palette.gray.main,
    color: '#fff',
  },
  red: {
    backgroundColor: theme.palette.red.main,
    color: '#fff',
  },
  input: {
    border: '0px',
    backgroundColor: "#000000",
    color: "#FFFFFF",
    borderRadius: '4px',
    padding: '12px',
    width: '350px',
    outlineColor: "#FFFFFF"
  },
  inputSearch: {
    border: '0px',
    backgroundColor: "#FFFFFF",
    borderRadius: '100px',
    padding: '12px',
    width: '350px',
    outlineColor: "#FFFFFF"
  },
  divHeader: {
    display: 'flex',
    justify: 'center',
    alignItems: 'center',
    marginBottom: '24px',
    justifyContent: 'space-between'
  },
  div: {
    height: '50px',
    width: '410px',
    backgroundColor: "#FFFFFF",
    padding: '6px',
    display: 'flex',
    justify: 'center',
    alignItems: 'center',
    borderRadius: '100px',
    boxShadow: theme.customShadows.widgetBlack,
  },
  divSearch: {
    height: '50px',
    width: '53px',
    padding: '2px',
    borderRadius: '100px',
    backgroundColor: "#FFFFF",
  },
  divAddButton: {
    height: '50px',
    width: '50px',
    backgroundColor: "#FFFFFF",
    marginLeft: '24px',
    display: 'flex',
    justify: 'center',
    alignItems: 'center',
    borderRadius: '100px',
    boxShadow: theme.customShadows.widgetBlack,
  },
  searchIcon: {
    borderRadius: '100px',
    padding: '8px',
    height: '100%',
    width: '100%',
    display: 'flex',
    justify: 'center',
    alignItems: 'center',
    color: "#000000",
    transition: theme.transitions.create("right"),
    "&:hover, &:focus": {
      cursor: "pointer",
      backgroundColor: "#F4F4F4",
      color: "#000000"
    }
  },
  divDeleteButton: {
    height: '35px',
    width: '35px',
    backgroundColor: "#FFFFFF",
    display: 'flex',
    justify: 'center',
    alignItems: 'center',
    borderRadius: '100px',
    margin: 'auto',
    boxShadow: theme.customShadows.widgetBlack,
  },
  divCard: {
    backgroundColor: "#000000",
    padding: '16px',
    justify: 'center',
    alignItems: 'center',
    borderRadius: '4px',
    boxShadow: theme.customShadows.widgetBlack,
  },
  divButton: {
    width: "100%",
    display: "flex",
    justify: "center",
    alignItems: "center",
    marginTop: "100px",
    marginBottom: "24px",
  },
  divTitle: {
    width: "100%",
    display: "flex",
    marginTop: "12px",
    marginLeft: "12px",
    marginBottom: "24px",
  },
  disableButton: {
    backgroundColor: "#F4F4F4",
    color: "#C9C9C9",
    fontSize: "20px",
    padding: "12px 60px",
    borderRadius: '6px',
    margin: "auto",
    borderWidth: "0px"
  },
  enableButton: {
    backgroundColor: "#FFFFFF",
    color: "#000000",
    fontSize: "20px",
    padding: "12px 60px",
    borderRadius: '6px',
    margin: "auto",
    cursor: 'pointer',
    borderWidth: "0px",
    boxShadow: theme.customShadows.widgetBlack,
  },
  enableButtonFinger: {
    backgroundColor: "#FFFFFF",
    color: "#000000",
    fontSize: "16px",
    padding: "4px 40px",
    borderRadius: '6px',
    margin: "auto",
    cursor: 'pointer',
    borderWidth: "0px",
    boxShadow: theme.customShadows.widgetBlack,
  },
  divColumn: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: '20px',
    ['@media (max-width:800px)']: {
      gridTemplateColumns: '1fr',
    },
    marginBottom: "24px",
  },
  divFinger: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: '20px',
  },
  titleStyle: {
    fontWeight: '500',
    fontSize: "28px",
    color: "#FFFFFF",
  },
  label: {
    display: 'block',
    fontWeight: '500',
    padding: '10px',
    minHeight: '40px',
    color: "#FFFFFF",
  },
  divLabel: {
    display: "flex",
    height: "40px",
    justify: 'center',
    alignItems: 'center'
  },
  formControl: {
    width: '85%',
  },
  selectEmpty: {
    marginTop: theme.spacing.unit * 2,
  },
  row: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: '20px',
    marginBottom: "24px",
  },
  textFieldTime: {
    width: '90%',
    color: "#FFFFFF",
    marginBottom: '8px',
    marginLeft: '8px'
  },
  divSwitch: {
    display: 'flex',
    justify: 'center',
    alignItems: 'center',
    paddingLeft: '8px',
  },
  inputForm: {
    backgroundColor: "#000000",
    color: "#FFFFFF",
    padding: '8px',
    width: '85%',
    fontSize: '18px',
  },
  textBorder: {
    "&:before": {
      borderBottomColor: '2px solid #F4F4F4'
    },
    "&:after": {
      borderBottomColor: '2px solid #000000'
    },
    "&:hover:before": {
      borderBottomColor: '2px solid #000000',
    },
  },
  footerTable: {
    marginTop: "60px",
    marginLeft: "24px",
    marginRight: "24px",
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    justify: 'spaceBetween'
  },
  footerTableFirstDiv: {
    display: "flex",
    float: "left",
    alignItems: 'center',
  },
  footerTableSecondDiv: {
    display: "flex",
    float: "right",
    alignItems: 'center',
  },
  footerText: {
    fontSize: "16px",
    color: "#FFFFFF",
    marginRight: "24px",
  },
  spaceBetweenButtons:{
    marginRight: "20px",
  },
  buttonPageEnable: {
    border: "solid",
    borderWidth: "1px",
    borderColor: "#EBEBEB",
    borderRadius: '4px',
    cursor: "pointer",
    padding: "8px 20px",
    backgroundColor: "#FFFFFF",
    justify: 'center',
    alignItems: 'center',
    fontSize: "13px",
  },
  buttonPageDisable: {
    border: "solid",
    borderWidth: "1px",
    borderColor: "#EBEBEB",
    borderRadius: '4px',
    padding: "8px 20px",
    backgroundColor: "#F4F4F4",
    color: "#C9C9C9",
    justify: 'center',
    alignItems: 'center',
    fontSize: "13px",
  },
  titleRow: {
    display: 'flex',
    alignItems: 'center',
  },
  divActionButton: {
    height: '40px',
    width: '40px',
    backgroundColor: "#FFFFFF",
    marginLeft: '20px',
    display: 'flex',
    justify: 'center',
    alignItems: 'center',
    borderRadius: '100px',
    boxShadow: theme.customShadows.widgetBlack,
  },
  marginAuto: {
    margin: "auto"
  },
  divActionButtonDisable: {
    height: '40px',
    width: '40px',
    backgroundColor: "#F4F4F4",
    marginLeft: '20px',
    display: 'flex',
    justify: 'center',
    alignItems: 'center',
    borderRadius: '100px',
    boxShadow: theme.customShadows.widgetBlack,
  },
  activeButtonDisable: {
    borderRadius: '100px',
    padding: '8px',
    height: '100%',
    width: '100%',
    display: 'flex',
    justify: 'center',
    alignItems: 'center',
  },
  loginPage: {
    display: "flex",
    justify: "center",
    alignItems: "center",
    margin: "auto",
    marginTop: "125px",
    marginBottom: "125px",
  },
  loginLoader: {
    display: "flex",
    justify: "center",
    alignItems: "center",
    margin: "auto"
  },
  headerTableStyle: {
    marginTop: "20px",
    marginBottom: "20px",
    width: "100%",
  },
  tableTextStyle: {
    color: "#FFFFFF",
    fontSize: "16px",
    borderBottom: 'none',
  },
  root: {
    "& .MuiTableCell-head": {
      color: "white",
      marginTop: "20px",
      marginBottom: "20px",
      fontSize: "16px",
      borderBottom: 'none',
    },
  },
  buttonPageEnableArrow: {
    color: theme.palette.red.main,
    cursor: "pointer",
    padding: '4px',
    height: '100%',
    width: '100%',
    display: 'flex',
    justify: 'center',
    alignItems: 'center',
    borderRadius: '100px',
    marginLeft: "3px",
  },
  buttonPageEnableArrowForward: {
    color: theme.palette.red.main,
    cursor: "pointer",
    padding: '4px',
    height: '100%',
    width: '100%',
    display: 'flex',
    justify: 'center',
    alignItems: 'center',
    borderRadius: '100px',
  },
  buttonPageEnableArrowDiv: {
    height: "30px",
    width: "30px",
    border: "solid",
    borderWidth: "1px",
    borderColor: theme.palette.red.main,
    borderRadius: '100px',
    display: "flex",
    justify: "center",
    alignItems: "center",
  },
  buttonPageDisableArrow: {
    color: "#7E1E1E",
    padding: '4px',
    height: '100%',
    width: '100%',
    display: 'flex',
    justify: 'center',
    alignItems: 'center',
    borderRadius: '100px',
    marginLeft: "3px",
  },
  buttonPageDisableArrowForward: {
    color: "#7E1E1E",
    padding: '4px',
    height: '100%',
    width: '100%',
    display: 'flex',
    justify: 'center',
    alignItems: 'center',
    borderRadius: '100px',
  },
  buttonPageDisableArrowDiv: {
    height: "30px",
    width: "30px",
    border: "solid",
    borderWidth: "1px",
    borderColor: "#7E1E1E",
    borderRadius: '100px',
    display: "flex",
    justify: "center",
    alignItems: "center",
  },
  inputSearchFull: {
    border: '0px',
    backgroundColor: "#FFFFFF",
    borderRadius: '4px',
    padding: '12px',
    width: '100%',
    outlineColor: "#FFFFFF"
  },
  searchDivFullWidthWithoutShadow: {
    height: '44px',
    width: '100%',
    backgroundColor: "#FFFFFF",
    padding: '6px',
    display: 'flex',
    justify: 'center',
    alignItems: 'center',
    borderRadius: '4px',
  },
  inputSearchFinger: {
    border: '0px',
    backgroundColor: "#FFFFFF",
    borderRadius: '4px',
    padding: '1px',
    width: '100%',
    outlineColor: "#FFFFFF"
  },
  divActionButton: {
    height: '40px',
    width: '40px',
    backgroundColor: "#FFFFFF",
    marginLeft: '20px',
    display: 'flex',
    justify: 'center',
    alignItems: 'center',
    borderRadius: '100px',
  },
  iconAcctionInventory: {
    borderRadius: '100px',
    padding: '8px',
    height: '100%',
    width: '100%',
    display: 'flex',
    justify: 'center',
    alignItems: 'center',
    color: "#000000",
    transition: theme.transitions.create("right"),
    "&:hover, &:focus": {
      cursor: "pointer",
      backgroundColor: "#F4F4F4",
      color: "#000000"
    }
  },
  iconAcctionInventoryDisable: {
    borderRadius: '100px',
    padding: '8px',
    height: '100%',
    width: '100%',
    display: 'flex',
    justify: 'center',
    alignItems: 'center',
    color: "#C9C9C9",
  },
  divDate: {
    backgroundColor: "#FFFFFF",
    borderRadius: '4px',
    color: "#000000",
  },
  labelDate: {
    display: 'flex',
    fontWeight: '500',
    padding: '10px',
    minHeight: '40px',
    color: "#000000",
  },
  inputDate: {
    backgroundColor: "#FFFFFF",
    color: "#000000",
    padding: '8px',
    width: '85%',
    fontSize: '18px',
    marginBottom: '4px'
  },
  labelTitle: {
    display: 'flex',
    fontWeight: '500',
    fontSize: '20px',
    color: "#FFFFFF",
  },
  tableRowStyle: {
    color: "#FFFFFF",
    fontSize: "16px",
    borderBottom: 'none',
  },
  tableRowStyleTitle: {
    color: "#FFFFFF",
    fontSize: "20px",
    borderBottom: 'none',
  },
  tableRowStyleTitleRight: {
    color: "#FFFFFF",
    fontSize: "20px",
    borderBottom: 'none',
    float: "right",
  },
  tableRowStyleTitleCashOut: {
    color: "#FFFFFF",
    fontSize: "28px",
    borderBottom: 'none',
  },
  tableRowStyleTitleCashOutMarginLeft: {
    color: "#FFFFFF",
    fontSize: "28px",
    borderBottom: 'none',
    marginLeft: '24px'
  },
  tableRowStyleSubTitleCashOut: {
    color: "#FFFFFF",
    fontSize: "22px",
    borderBottom: 'none',
    textAlign: 'right',
    marginRight: "50px",
  },
  tableRowStyleSubTitleCashOutMarginTop: {
    color: "#FFFFFF",
    fontSize: "22px",
    borderBottom: 'none',
    marginTop: '30px'
  },
  tableRowStyleBorder: {
    color: "#FFFFFF",
    fontSize: "16px",
  },
  halfRow: {
    width: '50%',
  },
  inputMembership: {
    backgroundColor: "#000000",
    color: "#FFFFFF",
    padding: '8px',
    width: '100%',
    fontSize: '18px',
    textAlign: 'center',
    '&::-webkit-outer-spin-button': {
      '-webkit-appearance': 'none',
      margin: 0,
    },
    '&::-webkit-inner-spin-button': {
      '-webkit-appearance': 'none',
      margin: 0,
    },
  },
}));
